import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { Contract } from "src/app/models/Contract";
import { CompanyService } from "src/app/services/company.service";
import { GlobalOverlayService } from "src/app/services/global-overlay.service";
import { ModalService } from "src/app/services/modal.service";

import { AuthService } from "./../../services/auth.service";
import { ContractService } from "./../../services/contract.service";

@Component({
  selector: "app-contract-details",
  templateUrl: "./contract-details.component.html",
  styleUrls: ["./contract-details.component.scss"],
  standalone: false,
})
export class ContractDetailsComponent implements OnInit, OnDestroy {
  readonly routeNameConstants = RouteNameConstants;
  readonly localizationConstants = LocalizationConstants;

  contracts: Contract;
  subscription: Subscription;
  contractRef: string;

  quickSearch: string = "";

  constructor(
    public modalService: ModalService,
    public contractService: ContractService,
    private companyService: CompanyService,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private globalOverlayService: GlobalOverlayService,
  ) {}

  ngOnInit() {
    this.subscription = this.onCompanyChange();
    this.contractRef = this.route.snapshot.paramMap.get("contractReference");

    if (!this.companyService.selectedCompany?.name) return;
    this.getContractInfo();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getContractInfo() {
    this.globalOverlayService.show();
    this.contractService
      .getContractInfo(this.companyService.selectedCompany.name, this.contractRef)
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe((response) => {
        if (!response) return;
        this.contracts = response;
      });
  }

  onCompanyChange() {
    return this.companyService.companyChange.subscribe(() => {
      this.redirectToContracts();
    });
  }

  redirectToContracts() {
    this.router.navigate([RouteNameConstants.CONTRACTS]);
  }

  get userVisible() {
    return this.auth.user?.isUserGroupProfile;
  }
}
